class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');

     // shippingcheck()
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);




function shippingcheck() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Check if the total items in the cart are exactly one
      if (cart.item_count === 1) {
        const shippingRowSelectors = 'div#CartDrawer tr.cart-item.cart-item-Shipping.Protection';
        if (!document.querySelector(shippingRowSelectors)) {
         document.querySelector('.shipping-container .switch input').checked = true;
         document.querySelector('.shipping-right .shipping-atc-container button').click();
         return;
       }
      }

      // Otherwise, check for a product with the handle 'shipping-protection'
      const hasProductWithHandle = cart.items.some(item => item.handle === 'shipping-protection');
      if (hasProductWithHandle) {
        console.log('Product with handle "shipping-protection" is in the cart.');
        document.querySelector('.shipping-container .switch input').checked = true;
      } else {
        document.querySelector('.shipping-container .switch input').checked = false;
      }
    })
    .catch(error => {
      console.error('Error fetching cart:', error);
    });
}

document.addEventListener('click', function (e) {
  const form = e.target.closest('form');
  
  if (!e.target.classList.contains('ev-mammoth-atc')) return;

  e.preventDefault();

  const formData = new FormData(form);
  const variantId = formData.get('id');

  let quantity = 1;
  const qtyInput = form.querySelector('.xb-upsell-input[name="quantity"]');
  if (qtyInput) {
    quantity = parseInt(qtyInput.value) || 1;
  }

  const GIFT_VARIANT_ID = 49962879189272;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: [
        { id: parseInt(variantId), quantity: quantity },
        { id: GIFT_VARIANT_ID, quantity: quantity }
      ]
    })
  })
    .then(res => res.json())
    .then(data => {
        fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates: {}, sections: ["cart-drawer", "cart-icon-bubble"] }),
        })
          .then((res) => res.json())
          .then((cart) => {
            document.querySelector("cart-drawer").renderContents(cart);
            document.querySelector("cart-drawer.drawer").classList.remove("is-empty");
          });
    })
    .catch(err => {
      console.error('Add to cart failed:', err);
    });
});
